var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -240 1200 1200",
    id: "svg6",
    sodipodiDocname: "home.svg",
    inkscapeVersion: "1.1 (c68e22c387, 2021-05-23)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview8",
    pagecolor: "#333333",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    showgrid: "false",
    inkscapeZoom: 0.34666667,
    inkscapeCx: 848.07692,
    inkscapeCy: 604.32692,
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1017,
    "inkscapeWindow-x": 3832,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 1116,961 H 760 V 405 H 439 V 961 H 84 V 214 l 515,-455 517,455 z",
    id: "path2",
    style: {
      fill: "#333333",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLight);
export default __webpack_public_path__ + "static/media/home_light.b7d427580e81bb97ff35c72e0ec0e401.svg";
export { ForwardRef as ReactComponent };